import { setXVtableMutations } from '../XVtable'
import Vue from 'vue'
import locStore from 'store2'
import { graphdata, getGraphUrl, setReportStatus, resetreportstatus, setGraphdata } from '../XVgraphcontrol.js'
import { util } from 'pevueglobal'
let lstore = locStore.namespace('Spe203Meldingen')
const state = {
  meldingenTable: {
    tablesetting: {},
    tablecolumnsetting: [],
    tabledata: [],
    rowvisible: [],
  },
  meldingenSettings: {
    loadingNewItems: false,
    pageNumberLoaded: 1,
    inboxCount: null,
    archiveCount: null,
    loadedAllMessages: false,
    archiveToggle: false,
    sortorder: 0,
    search: '',
  },
  waiter: false,
  graphdata: [],
  messageId: '',
}

// getters
const getters = {
  meldingenTable: (state) => state.meldingenTable,
  archiveCount: (state) => state.meldingenSettings.archiveCount,
  inboxCount: (state) => state.meldingenSettings.inboxCount,
  archiveToggle: (state) => state.meldingenSettings.archiveToggle,
  search: (state) => state.meldingenSettings.search,
  isDetailOpen: (state) => (tblMessageID) => {
    return state.meldingenTable.tabledata.find((melding) => melding.tblMessageID === tblMessageID).tableRowState
      .rowVisible
  },
  waiter: (state) => state.waiter,
  viewProfAsAdmin: (state) => (state.meldingenTable != null ? state.meldingenTable.viewProfAsAdmin : false),
  profPersonId: (state) => (state.meldingenTable != null ? state.meldingenTable.profPersonId : null),
  profPersonName: (state) => (state.meldingenTable != null ? state.meldingenTable.profPersonName : null),
  showLinkActiviteiten: (state) => state.meldingenTable.showLinkActiviteiten,
  showLinkProfDetail: (state) => state.meldingenTable.showLinkProfDetail,
  showLinkMutatie: (state) => state.meldingenTable.showLinkMutatie,
  showLinkStatusoverzicht: (state) => state.meldingenTable.showLinkStatusoverzicht,
  showLinkMSF: (state) => state.meldingenTable.showLinkMSF,
  adminWelcomeText: (state) => state.meldingenTable.adminWelcomeText,
  graphdata: graphdata('graphdata'),
  messageId: (state) => state.messageId,
}

// actions
const actions = {
  getTexten: async ({ dispatch }) => {
    let textIDs = [
      243, 334, 1333, 1335, 3510, 3511, 3512, 4698, 4699, 4770, 4773, 4771, 4772, 4774, 4775, 4829, 4844, 4845, 7641,
      8032, 10367, 12339, 12340, 12734, 12735, 12736, 12737, 12738, 12739, 12740, 12741, 12742, 13251, 13252, 14455,
      15549,
    ]
    dispatch('gettranslations', textIDs, { root: true })
  },

  getGraphUrl: getGraphUrl('setReportStatus'),
  setSessionFilterState: async ({ state, commit }) => {
    commit('setSessionFilterState')
  },
  setUrlQueryParams: async ({ state }, queryParams) => {
    state.urlQueryParams = queryParams
  },
  setMessageId: async ({ state }, msgId) => {
    state.messageId = msgId
  },
  getInboxCount: async ({ state, commit }, IsArchive) => {
    if (state.meldingenSettings.archiveToggle) {
      let data = await util.getDataApi('allroles/PEapi_meldingenArchiveCount', { queryParams: state.urlQueryParams })

      commit('setArchiveCount', data)
    } else {
      let data = await util.getDataApi('allroles/PEapi_meldingenInboxCount', { queryParams: state.urlQueryParams })

      commit('setInboxCount', data)
    }
  },
  getMeldingen: async ({ state, commit, dispatch }) => {
    commit('meldingenremoveAll')
    const d = {
      isArchived: state.meldingenSettings.archiveToggle,
      search: state.meldingenSettings.search,
      sortOrderMeldingen: state.meldingenSettings.sortorder,
      pageNumber: state.meldingenSettings.pageNumberLoaded,
      queryParams: state.urlQueryParams,
    }

    const XVTablePEapiMeldingen = await util.getDataApi('allroles/PEapi_meldingen', d)

    commit('meldingeninitXVtableState', XVTablePEapiMeldingen)
    state.meldingenSettings.loadedAllMessages = false
    commit('stopLoading', null, { root: true })
    $('html, body').animate({ scrollTop: 0 }, 'fast')
    let graphdataInput = {
      pagename: 'SPE310_BH_HoofdschermV2.aspx',
      clientid: '',
    }
    const [graphdata] = await Promise.all([
      util.getDataApi('allroles/PEapi_GraphControl_Get_Available_Graphs', graphdataInput),
    ])
    commit('setGraphdata', graphdata)
    dispatch('getInboxCount')
  },
  setToggleArchive({ state, dispatch, commit }) {
    commit('setToggleArchive')
    dispatch('getMeldingen')
  },
  changeSortMeldingen({ dispatch, commit }, sortid) {
    commit('changeSortMeldingen', sortid)
    dispatch('getMeldingen')
  },
  setMeldingenSearch({ dispatch, commit }, search) {
    commit('setSearch', search)
    dispatch('getMeldingen')
  },
  setArchiveMeldingen: async ({ state, dispatch, commit }, { Archive }) => {
    // Niet mogelijk als een beheerder de inbox van een prof bekijkt
    if (state.meldingenTable == null || state.meldingenTable.viewProfAsAdmin) {
      return
    }

    let meldingIds = []
    state.meldingenTable.tabledata.forEach((row, index) => {
      if (row.tableRowState.selected) {
        meldingIds.push(row.tblMessageID)
      }
    })
    if (meldingIds.length !== 0) {
      // archive in parts, first divide ids in group of 10

      let setWithmeldingIds = []
      let size = 50
      // maak sets van 25 die moeten worde geupdate
      while (meldingIds.length > 0) {
        setWithmeldingIds.push({ meldingIds: meldingIds.splice(0, size), Archive })
      }
      // haal generator op die de async afhandeling van de update doet
      let updateMeldingenApiSequence = util.generateApiSequence(
        'allroles/PEapi_ArchiveMeldingen',
        setWithmeldingIds,
        500
      )
      for await (let meldingIds of updateMeldingenApiSequence) {
        commit('setArchiveMeldingen', meldingIds)
        dispatch('checkmail', null, { root: true }) // inbox count in menu
        dispatch('getInboxCount') // inbox count op meldingen scherm
      }
    }
  },
  setReadUnreadMeldingen: async ({ state, dispatch, commit }, { read }) => {
    // Niet mogelijk als een beheerder de inbox van een prof bekijkt
    if (state.meldingenTable == null || state.meldingenTable.viewProfAsAdmin) {
      return
    }

    let meldingIds = []
    state.meldingenTable.tabledata.forEach((row, index) => {
      if (row.tableRowState.selected) {
        meldingIds.push(row.tblMessageID)
      }
    })
    if (meldingIds.length !== 0) {
      await util.getDataApi('allroles/PEapi_ReadUnreadMeldingen', {
        meldingIds,
        read,
        queryParams: state.urlQueryParams,
      })
      commit('setReadUnreadMeldingen', { meldingIds, read })
      dispatch('checkmail', null, { root: true }) // inbox count in menu
    }
  },
  getNewMeldingen: async ({ state, commit }, inputdata) => {
    commit('startLoading', { showmessage: false, disablepage: false }, { root: true })

    if (!state.meldingenSettings.loadingNewItems && !state.meldingenSettings.loadedAllMessages) {
      commit('setMeldingenPageCount')
      const d = {
        isArchived: state.meldingenSettings.archiveToggle,
        search: state.meldingenSettings.search,
        sortOrderMeldingen: state.meldingenSettings.sortorder,
        pageNumber: state.meldingenSettings.pageNumberLoaded,
        queryParams: state.urlQueryParams,
      }
      state.meldingenSettings.loadingNewItems = true
      const XVTablePEapiMeldingen = await util.getDataApi('allroles/PEapi_meldingen', d)

      commit('meldingenaddXVtableItems', XVTablePEapiMeldingen)
    }
    commit('stopLoading', null, { root: true })
  },
  getMeldingDetail: async ({ state, commit, dispatch }, tblMessageID) => {
    state.meldingenSettings.loadingNewItems = true
    const meldingDetailData = await util.getDataApi('allroles/PEapi_getmelding', {
      meldingid: tblMessageID,
      queryParams: state.urlQueryParams,
    })

    commit('setMeldingDetail', { tblMessageID, meldingDetailData })
    dispatch('checkmail', null, { root: true }) // inbox count in menu
    commit('stopLoading', null, { root: true })
    setTimeout(() => {
      state.meldingenSettings.loadingNewItems = false
    }, 2000)
  },
}

// mutations
const mutations = {
  ...setXVtableMutations('meldingenTable'),
  setReportStatus: setReportStatus('graphdata'),
  resetreportstatus: resetreportstatus('graphdata'),
  setGraphdata: setGraphdata('graphdata'),

  meldingenremoveAll: (state) => {
    state.meldingenTable = { tablesetting: {}, tablecolumnsetting: [], tabledata: [], rowvisible: [] }
    state.meldingenSettings.pageNumberLoaded = 1
    state.meldingenSettings.inboxCount = null
    state.meldingenSettings.archiveCount = null
    state.meldingenSettings.loadedAllMessages = null
  },
  meldingeninitXVtableState: (state, data) => {
    if (data !== undefined) {
      state.meldingenTable = data
    }
    // alle detailrijen dichtgeklapt
    state.meldingenTable.tabledata.forEach((row, index) => {
      Vue.set(row, 'tableRowState', {
        rowVisible: false,
        editModus: false,
        storeTableindex: index,
        selected: false,
        setRead: row.tblMessageDateTimeRead !== null,
      })
    })
    state.meldingenTable.tablecolumnsetting.push({
      columnname: 'tableRowState',
      tblPEapiProcTableColumnName: 'tableRowState',
      tblPEapiProcTableColumnNameTextID: null,
      tblPEapiProcTableColumnSequence: state.meldingenTable.tablecolumnsetting.length + 1,
      tblPEapiProcTableColumnSortColumn: null,
      tblPEapiProcTableColumnSortable: 0,
      tblPEapiProcTableColumnSortableDefault: 0,
      tblPEapiProcTableColumnType: null,
      tblPEapiProcTableColumnVisible: 0, // zet deze op visible om debuging info te krijgen van de tablerowstate
      tblPEapiProcTableColumnVisibleMD: null,
      tblPEapiProcTableColumnVisibleSM: null,
      tblPEapiProcTableColumnVisibleXS: null,
      tblPEapiProcTableColumnWidthMD: null,
      tblPEapiProcTableColumnWidthSM: null,
      tblPEapiProcTableColumnWidthXS: null,
      tblPEapiProcTableName: 'meldingenTable',
      tblPEapiProcTableProcedure: '',
      tblPEapiProcTableColumnHelpTextID: null,
    })
  },
  setSessionFilterState(state) {
    state.meldingenSettings.archiveToggle = lstore.session('StateToggleArchive')
      ? lstore.session('StateToggleArchive')
      : state.meldingenSettings.archiveToggle
    state.meldingenSettings.sortorder = lstore.session('StateSortorder')
      ? lstore.session('StateSortorder')
      : state.meldingenSettings.sortorder
    state.meldingenSettings.search = lstore.session('StateSearchValue')
      ? lstore.session('StateSearchValue')
      : state.meldingenSettings.search
  },
  setInboxCount(state, inboxCount) {
    state.meldingenSettings.inboxCount = inboxCount
  },
  setArchiveCount(state, archiveCount) {
    state.meldingenSettings.archiveCount = archiveCount
  },
  setToggleArchive(state) {
    state.meldingenSettings.pageNumberLoaded = 0
    state.meldingenSettings.archiveToggle = !state.meldingenSettings.archiveToggle
    state.meldingenSettings.archiveToggle === true
      ? lstore.session('StateToggleArchive', true)
      : lstore.session('StateToggleArchive', false)
  },
  setReadUnreadMeldingen(state, { meldingIds, read }) {
    state.meldingenTable.tabledata.forEach((row, index) => {
      if (meldingIds.includes(row.tblMessageID)) {
        if (!state.meldingenTable.viewProfAsAdmin) {
          Vue.set(row.tableRowState, 'setRead', read)
        }
        Vue.set(row.tableRowState, 'selected', false)
      }
    })
  },
  setArchiveMeldingen(state, { meldingIds, Archive }) {
    // eslint-disable-next-line
    for (var i = state.meldingenTable.tabledata.length; i--; ) {
      if (meldingIds.includes(state.meldingenTable.tabledata[i].tblMessageID)) {
        state.meldingenTable.tabledata.splice(i, 1)
      }
    }
  },
  setMeldingDetail(state, { tblMessageID, meldingDetailData }) {
    let melding = state.meldingenTable.tabledata.find((melding) => melding.tblMessageID === tblMessageID)

    if (!state.meldingenTable.viewProfAsAdmin) {
      Vue.set(melding.tableRowState, 'setRead', true)
    }

    // set detail data in melding row, we gebruiken tableRowstate hier omdat de melding.tblMessageDetails niet werkt, dit heeft te maken met de filtering van de data in de xvtable
    Vue.set(melding.tableRowState, 'tblMessageDetails', meldingDetailData)
  },
  changeSortMeldingen(state, sortid) {
    state.meldingenSettings.sortorder = sortid
    lstore.session('StateSortorder', sortid)
  },
  setSearch(state, search) {
    state.meldingenSettings.search = search
    lstore.session('StateSearchValue', search)
  },
  setMeldingenPageCount(state) {
    state.meldingenSettings.pageNumberLoaded = state.meldingenSettings.pageNumberLoaded + 1
  },
  meldingenaddXVtableItems(state, data) {
    if (data.tabledata.length === 0) {
      state.meldingenSettings.loadedAllMessages = true
    } else {
      state.meldingenTable.tabledata = [...state.meldingenTable.tabledata, ...data.tabledata]
      state.meldingenTable.tabledata.forEach((row, index) => {
        // maak voor alle nieuwe rows een state object aan
        if (!row.tableRowState) {
          Vue.set(row, 'tableRowState', {
            rowVisible: false,
            editModus: false,
            storeTableindex: index,
            selected: false,
            setRead: row.tblMessageDateTimeRead !== null,
          })
        }
      })
    }

    state.meldingenSettings.loadingNewItems = false
    // if (data !== undefined) {
    //   state[XVtablename] = data
    // }
  },
  togglewaiter(state, data) {
    state.waiter = data
  },
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
